import { LoaderCircle } from 'lucide-react';
import React from 'react';
import { cn } from '@core/utils/cn';

const sizes = { sm: 'size-4', md: 'size-6', lg: 'size-8' };

interface SpinnerProps {
    size?: keyof typeof sizes;
    className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
    return (
        <LoaderCircle
            className={cn('animate-spin text-primary', sizes[size], className)}
        />
    );
}
